/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HalJson } from '../../models/hal-json';
import { ItemVariantResult } from '../../models/item-variant-result';

export interface ItemVariantsGet$Params {
  'Active-Tenant-Identifier': string;
}

export function itemVariantsGet(http: HttpClient, rootUrl: string, params: ItemVariantsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
'_embedded'?: {
'itemVariants'?: Array<ItemVariantResult>;
};
}>> {
  const rb = new RequestBuilder(rootUrl, itemVariantsGet.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      '_links'?: HalJson;
      '_embedded'?: {
      'itemVariants'?: Array<ItemVariantResult>;
      };
      }>;
    })
  );
}

itemVariantsGet.PATH = '/item-variants';
